import { PERMISSIONS } from '../../constants';
import list from './CustomerRecoveryRuleList';
import create from './CustomerRecoveryRuleCreate';
import show from './CustomerRecoveryRuleShow';

export default {
  list,
  create,
  show,
  name: 'customer-recovery-rules',
  permissions: [PERMISSIONS.CUSTOMER_RECOVERY_RULES],
  hasShow: true,
  hasEdit: false,
};
